import { Component  } from '@angular/core';
import { ParametrosImpositivos } from '@shared/models/facturacion/ParametrosImpositivos';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ModalProvinciaV2Component } from './modal-provincia/modal-provincia-v2.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParametrosImpositivosService } from '../parametros-impositivos.service';

@Component({
  selector: 'app-parametros-impositivos-index',
  templateUrl: 'parametros-impositivos-index.component.html',
  styleUrls: ['./parametros-impositivos-index.component.css']
})
export class ParametrosImpositivosIndexComponent {

  obteniendoParametros: boolean;
  parametroSeleccionado: ParametrosImpositivos;

  textoBusquedaProvincia:string;

  busquedaForm = new UntypedFormGroup({
    busquedaFormControl: new UntypedFormControl('')
  })
  
  constructor(
    private modalService: NgbModal,
    private parametrosService: ParametrosImpositivosService
  ) { }

  onAgregarProvincia() {
    this.modalService.open(ModalProvinciaV2Component, { centered: true, backdrop: 'static' })
      .result.then((provincia) => {
        this.parametrosService.crearParametroImpositivoEncabezado(provincia);
      }).catch(() => { /*No hacer nada*/ });
  }

  filtrarProvincias(){
    const textoBusqueda :string = this.busquedaForm.controls.busquedaFormControl.value;
    this.textoBusquedaProvincia = textoBusqueda;
  }
}
